var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"icon":"","disabled":_vm.loadingFavourites,"loading":_vm.loading},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.toggleFavourite.apply(null, arguments)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.isFavourite ? 'mdi-star' : 'mdi-star-outline'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }